import React from 'react';
import { useEventModal } from '../../hooks/EventHook';
import { WP_Event } from '../../model/models';
import { Modal } from '../globals/Modal';
import { SanitizeHTML } from '../globals/SanitizeHTML';
import { EventModalContent } from './EventModaleContent';
import { EventOrganisator } from './EventOrganisator';
import { FormattedMessage } from 'react-intl';
import { DateToIcon } from './DateToIcon';

export const EventItem = (event: WP_Event, baseUrl: string, key: number) => {
  const {
    start_date,
    start_hour,
    end_date,
    end_hour,
    eventHouseThumbnailUrl,
    eventHouseName,
    featuredImage,
    places,
  } = useEventModal(event);

  const origin = event.acf.origin;
  const showHours = origin === 'portail';

  return (
    <li key={key}>
      <Modal
        content={
          <EventModalContent
            event={event}
            start_date={start_date}
            start_hour={start_hour}
            end_date={end_date}
            end_hour={end_hour}
            eventHouseThumbnailUrl={eventHouseThumbnailUrl}
            eventHouseName={eventHouseName}
            places={places}
          />
        }
        ModalUrl={baseUrl + '/' + event.slug}
        backUrl={baseUrl}
      >
        <div className="events-block mb-10 lg:mb-0 md:bg-white md:rounded-2xl md:p-4">
          <div className="flex flex-col items-center justify-around event-dates h-auto border-small border-primary rounded-2xl p-2 md:border-0 md:p-0">
            <label className="text-2xs font-sans font-medium text-black md:text-xs">
              {start_date}
            </label>
            {showHours && (
              <label className="text-2xs font-sans text-black md:text-xs">
                {start_hour}
              </label>
            )}
            {end_date !== '' && (
              <>
                <DateToIcon />
                <label className="text-2xs font-sans font-medium md:text-xs">
                  {end_date}
                </label>
                {showHours && (
                  <label className="text-2xs font-sans md:text-xs">
                    {end_hour}
                  </label>
                )}
              </>
            )}
          </div>
          <div className="event-thumbnail-event ml-3">
            {featuredImage && (
              <img className="rounded-2xl w-full" src={featuredImage} alt="" />
            )}
          </div>
          <div className="flex flex-col justify-between events-headcontent ml-3">
            <SanitizeHTML
              tag="h2"
              className="text-sm font-sans font-medium text-left line-clamp-3"
              html={event.title.rendered}
            />
            {places?.length > 0 && (
              <p className="font-sans font-medium text-black opacity-60 text-xs text-left">
                <FormattedMessage id="Place" />
                <span className="font-bold ml-1">
                  {places.map((place, id) => {
                    const place_name: string = place['name'];
                    return places.length - 1 !== id
                      ? place_name + ', '
                      : place_name;
                  })}
                </span>
              </p>
            )}
            <EventOrganisator
              thumbnailUrl={eventHouseThumbnailUrl}
              name={eventHouseName}
            />
          </div>
        </div>
      </Modal>
    </li>
  );
};
